import React from 'react';
export var CloseIcon = function () { return (React.createElement("svg", { viewBox: "-2 -2 16 16", width: "12", height: "12", fill: "#888" },
    React.createElement("path", { d: "M7.42 6L12 1.42 10.58 0 6 4.58 1.42 0 0 1.42 4.58 6 0 10.58 1.42 12 6 7.42 10.58 12 12 10.58 7.42 6z" }))); };
//# sourceMappingURL=CloseIcon.js.map